import run from './main.run';

export default angular
    .module('BB.uib', [
        'ui.bootstrap'
    ])
    .run(run)
    .name;




// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-uib/main.module.js